<section class="child-page grid-max-width center">
  <div class="grid-col-12 grid-max-width no-row-gap white-bg surface-primary relative rounded-large">
    <!-- Section navigation -->
    <fin-section-navi class="col-1-12 md-col-1-3 sm-col-2-11 mr-xlarge-t" [nested]="true" />

    <!-- Child page content -->
    <section class="col-1-12 md-col-4-12 sm-col-2-11 mr-medium-t content-section">
      <div class="grid-col-12 col-1-12 no-gutters">
        @if (title$ | async; as title) {
          <h1
            class="article-title nordic-blue-900-text text-icon-primary mr-small-y font-heading-1 col-1-12 md-col-1-8 font-headline-medium"
          >
            {{ title }}
          </h1>
        }
      </div>
      <fin-cms-json-content class="grid-col-12 no-gutters no-row-gap" [template$]="template$" />
    </section>
  </div>
</section>
